/** Cuánto puede durar una toma del repaso hablado (`CoachReview`). */

/** Tope de una toma: una corrección se dice en pocos segundos. */
const MAX_TAKE_MS = 12_000;
/** El tope de una frase larga: 0,8 s por palabra, hasta 40 s (el de la escucha en vivo). */
const MS_PER_WORD = 800;
const MAX_LONG_TAKE_MS = 40_000;
/**
 * Cuánto puede durar la toma de ESTA frase. El ejemplo de una palabra guardada llega a ~40
 * palabras (34 en el más largo, 238 letras): con los 12 s de una corrección la toma se cortaba a mitad de la frase y
 * no pasaba nunca (card #568, 20/10).
 */
export function takeLimitMs(phrase: string): number {
  const words = phrase.trim().split(/\s+/).filter(Boolean).length;
  return Math.min(MAX_LONG_TAKE_MS, Math.max(MAX_TAKE_MS, words * MS_PER_WORD));
}
